export default [
    { key: 1, text: 'Segunda', value: 1 },
    { key: 2, text: 'Terça', value: 2 },
    { key: 3, text: 'Quarta', value: 3 },
    { key: 4, text: 'Quinta', value: 4 },
    { key: 5, text: 'Sexta', value: 5 },
    { key: 6, text: 'Sábado', value: 6 },
    { key: 7, text: 'Domingo', value: 7 }
]
